import { accountActions } from './accountActions';
import { appConfigAction } from './common/appConfigAction';
import { commonActions } from './commonActions';

export const actions = {
    account: accountActions,
    appConfig: appConfigAction,
    common: commonActions,
}